module.exports = __webpack_public_path__ + "img/rewards-thumbs-up.94c2afda.png";